document.addEventListener("DOMContentLoaded", function () {
 const rotateSpan = document.querySelector(".merge-2025-h1-rotate");
 const cells = document.querySelectorAll(".merge-2025-block-components-cell");

 if (rotateSpan && cells.length > 0) {
   cells.forEach((cell) => {
     cell.addEventListener("click", () => {
       cells.forEach((c) => c.classList.remove("selected"));
       cell.classList.add("selected");
     });
   });

   const words = ["MUI", "Ant Design", "Bootstrap", "Tailwind CSS", "UXPin Classic"];
   let index = 0;

   setInterval(() => {
     rotateSpan.style.opacity = 0;
     setTimeout(() => {
       index = (index + 1) % words.length;
       rotateSpan.textContent = words[index];
       rotateSpan.style.opacity = 1;
     }, 300);
   }, 2000);
 }
});
